export const FILE_REQUEST_LOCALES = Object.freeze(["ro", "en", "ru", "de"]);

export const FILE_REQUEST_LOCALE_LABELS = Object.freeze({
  ro: "Română",
  en: "English",
  ru: "Русский",
  de: "Deutsch",
});

export const FILE_REQUEST_FORMATS = Object.freeze([
  ".dxf",
  ".dwg",
  ".step",
  ".stp",
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
]);

export const DEFAULT_FILE_REQUEST_LOCALES = Object.freeze({
  ro: Object.freeze({
    eyebrow: "Ofertă gratuită",
    title: "Spuneți-ne despre proiectul dvs.",
    subtitle: "Descrieți pe scurt de ce aveți nevoie — veți primi în 48 de ore o ofertă cu preț fix, fără obligații.",
    nameLabel: "Nume complet",
    namePlaceholder: "Numele dvs.",
    phoneLabel: "Număr de contact",
    phonePlaceholder: "+49 ...",
    contentLabel: "Conținut",
    contentPlaceholder: "Descrieți pe scurt proiectul sau solicitarea dvs.",
    consentLabel: "Sunt de acord să fiu contactat de MiriDar în baza datelor transmise.",
    submitLabel: "Solicită oferta",
  }),
  en: Object.freeze({
    eyebrow: "Free quote",
    title: "Tell us about your project",
    subtitle: "Briefly describe what you need — you’ll get a non-binding fixed-price quote within 48 hours.",
    nameLabel: "Full name",
    namePlaceholder: "Your name",
    phoneLabel: "Contact number",
    phonePlaceholder: "+49 ...",
    contentLabel: "Project details",
    contentPlaceholder: "Briefly describe your project or request.",
    consentLabel: "I agree to be contacted by MiriDar based on the information submitted.",
    submitLabel: "Request a quote",
  }),
  ru: Object.freeze({
    eyebrow: "Бесплатное предложение",
    title: "Расскажите нам о вашем проекте",
    subtitle: "Кратко опишите, что вам нужно — в течение 48 часов вы получите необязывающее предложение с фиксированной ценой.",
    nameLabel: "Полное имя",
    namePlaceholder: "Ваше имя",
    phoneLabel: "Контактный номер",
    phonePlaceholder: "+49 ...",
    contentLabel: "Описание проекта",
    contentPlaceholder: "Кратко опишите ваш проект или запрос.",
    consentLabel: "Я согласен(на), чтобы MiriDar связалась со мной на основании отправленных данных.",
    submitLabel: "Запросить предложение",
  }),
  de: Object.freeze({
    eyebrow: "Kostenloses Angebot",
    title: "Erzählen Sie uns von Ihrem Projekt",
    subtitle: "Kurz beschreiben, worum es geht — Sie erhalten innerhalb von 48 Stunden ein unverbindliches Festpreis-Angebot.",
    nameLabel: "Vollständiger Name",
    namePlaceholder: "Ihr Name",
    phoneLabel: "Kontaktnummer",
    phonePlaceholder: "+49 ...",
    contentLabel: "Projektbeschreibung",
    contentPlaceholder: "Beschreiben Sie kurz Ihr Projekt oder Ihre Anfrage.",
    consentLabel: "Ich stimme zu, dass MiriDar mich auf Grundlage der übermittelten Daten kontaktiert.",
    submitLabel: "Angebot anfordern",
  }),
});

const deepClone = (value) => JSON.parse(JSON.stringify(value));

export const normalizeFileRequestLocales = (value = {}) =>
  Object.fromEntries(
    FILE_REQUEST_LOCALES.map((locale) => [
      locale,
      {
        ...deepClone(DEFAULT_FILE_REQUEST_LOCALES[locale]),
        ...(value?.[locale] || {}),
      },
    ])
  );

export const normalizeFileRequestFormats = (value) => {
  const requested = Array.isArray(value) ? value : FILE_REQUEST_FORMATS;
  const supported = new Set(FILE_REQUEST_FORMATS);
  const normalized = requested
    .map((extension) => {
      const cleaned = String(extension || "").trim().toLowerCase();
      return cleaned && !cleaned.startsWith(".") ? `.${cleaned}` : cleaned;
    })
    .filter((extension) => supported.has(extension));
  return normalized.length ? [...new Set(normalized)] : [...FILE_REQUEST_FORMATS];
};
